import React from 'react';
// import ChatPanel from 'app/fuse-layouts/shared-components/chatPanel/ChatPanel';
// import QuickPanel from 'app/fuse-layouts/shared-components/quickPanel/QuickPanel';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';



function RightSideLayout1(props) {
	const location = useLocation();
	// const pagesCtm = location.pathname.startsWith("/ctm");
	// const pagesChat = location.pathname.startsWith("/chat");
	const getSideMenuItems = useSelector(({ multipleCompanies }) => multipleCompanies && multipleCompanies.multipleCompanies.getSideMenuItems);
	const sideMenuItems = getSideMenuItems?.data?.map(list => list);
	const connectItem = sideMenuItems && sideMenuItems.some(list => list.name === 'Connect');

	return (
		connectItem &&
			<>
				{/* {!pagesChat && !pagesCtm && <ChatPanel />}
				<QuickPanel /> */}
			</>
	);
}

export default React.memo(RightSideLayout1);